import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import api from "../../api/axios"; // Path to your axios instance
import { toast } from "react-toastify";
import {moneyFromMinor} from '../utils/UnitConversion.utils';
import {useSelector} from 'react-redux';
import {RootState} from '../../store';
import {useCurrency} from '../../hooks/useCurrency';

// CountUp component
const CountUp = ({ end, duration = 1800, prefix = '', suffix = '', decimals = 0 }: any) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let startTime: number | null = null;
    const step = (timestamp: number) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      const easeOutQuart = 1 - Math.pow(1 - progress, 4);
      setCount(easeOutQuart * end);
      if (progress < 1) window.requestAnimationFrame(step);
    };
    window.requestAnimationFrame(step);
  }, [end, duration]);

  return <span>{prefix}{count.toLocaleString('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals })}{suffix}</span>;
};

const Stats = () => {
  const {t} = useTranslation();
  const [stats, setStats] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const currencySymbol = useSelector((state: RootState) => state.currency.symbol);
  const { convertFromUSD} = useCurrency()

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const res = await api.get("/landing-page/stats");
        setStats(res.data);
      } catch (e) {
        toast.error(t('landing_page.stats.error'));
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  const statsData = [
    { val: 1.5, label: t('landing_page.stats.fees'), suffix: "%", dec: 1 },
    {
      val: stats?.totalOffers || 0,
      label: t('landing_page.stats.skins_listed')
    },
    {
      val: convertFromUSD(moneyFromMinor(stats?.totalVolumeMinor)),
      label: t('landing_page.stats.total_volume'),
      prefix: currencySymbol,
      dec: 0
    },
    {
      val: stats?.itemsSold || 0,
      label: t('landing_page.stats.items_sold')
    }
  ];

  return (
      <section className="max-w-[1600px] mx-auto px-6 md:px-8 md:py-8 py-0 pb-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 xl:gap-8">
          {statsData.map((stat, i) => (
              <div
                  key={i}
                  className="bg-neutral-50 dark:bg-neutral-900/30 p-8 xl:p-10 rounded-2xl backdrop-blur-xl shadow-xl transition-all group min-w-0 border border-neutral-200 dark:border-white/5 hover:border-dark-primary/30"
              >
                <div className="text-3xl xl:text-4xl font-black mb-3 truncate text-light-text dark:text-dark-text">
                  {loading ? (
                      <span className="opacity-20">{t('landing_page.stats.loading')}</span>
                  ) : (
                      <CountUp
                          end={stat.val}
                          suffix={stat.suffix || ''}
                          prefix={stat.prefix || ''}
                          decimals={stat.dec || 0}
                      />
                  )}
                </div>
                <div className="text-gray-500 dark:text-slate-500 font-bold uppercase tracking-widest text-[10px] xl:text-xs group-hover:text-dark-primary transition-colors whitespace-nowrap overflow-hidden">
                  {stat.label}
                </div>
              </div>
          ))}
        </div>
      </section>
  );
};

export default Stats;